/*
 * Name        : DFA Main Nav Module
 * Version     : 0.3.1
 * Author      : Deep Fried Advertising
 * Author URL  : https://deepfriedads.com
 * Description : Adds event listeners to add class to fixed nav
*/

import { $, $html, $menu_button } from './_var';

const $nav_wrap = $('header.container');
const $wap_stick = 'wrapper-stick';
const $main_nav = $( '.main-nav' );
const $sticky		= 'nav-stick';
const $window		= $(window);
const $screen_height = $window.height();

const setup_sticky_nav = () =>
{
	$window.scroll( function()
	{
		var $head_height = $window.scrollTop();
		var $quarter_screen = $screen_height / 8;

		if ( $head_height < $quarter_screen )
			{
				$main_nav.removeClass( $sticky );
				$nav_wrap.removeClass( $wap_stick );
			}
		else
			{
				$main_nav.addClass( $sticky );
				$nav_wrap.addClass( $wap_stick );
			}
		});
};

export { setup_sticky_nav };
